<template>
    <section class="resume-section fade-out-element">
        <div class="resume-container ">
            <h1 class="inter-500">Resumen</h1>
            <p class="source-code-pro-300 text-in-1 ">
                ¡Hola! Soy Ingeniero en Sistemas Computacionales enfocado en construir soluciones tecnológicas
                eficientes, estables y centradas en el usuario. <br>Mi experiencia se divide en dos grandes mundos: el
                <b>desarrollo Frontend moderno</b> (creando interfaces dinámicas con JavaScript, TypeScript, Vue y Angular) y
                la robustez del <b>Backend en el sector bancario</b> (analizando y optimizando sistemas críticos en entornos
                Unisys/COBOL74). Me apasiona la arquitectura limpia, la optimización de código y transformar
                requerimientos complejos en aplicaciones web de alto impacto.
            </p>
        </div>
    </section>
</template>

<script setup lang="ts">

</script>

<style scoped>
.resume-section {
    background-color: var(--main-bg-color);
    margin-top: 1.6em;
}

.resume-container {
    background-color: var(--secondary-bg-color);
    padding: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: left;
    color: var(--main-bg-color);
    border-radius: 1.3em;
    font-size: 1em;
    height: 500px;
}

p {
    width: 100%;
    padding-top: 1em;

}

@media (min-width: 576px) {
    .resume-container {
        padding: 4em;
        border-radius: 2.5em;
        height: max-content;
    }

    p {
        width: 60%;
        padding: 2em;
        font-size: 1.1em;
    }
}
</style>